<div>
    <div class="container">


        <div class="biglietto p-2">

            <h2 class="text-center mb-3">Diventa Socio</h2>
            <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum iure dolores quo enim error pariatur eos veniam autem commodi corrupti sint praesentium quam similique nisi quia reprehenderit, voluptate natus a?</span>

            <div class="my-15 text-center">
                <button mat-flat-button color="primary" [disabled]="richiestaInviata" (click)="invia()">{{ 'Invia richiesta' | translate }}</button>
            </div>

            <div *ngIf="richiestaInviata">

                <div class="text-center">
                    <span>La tua richiesta è stata inviata correttamente, attendi conferma dal Golf Club</span>
                </div>

            </div>

        </div>

    </div>
</div>